module.exports = __webpack_public_path__ + "img/whitedownarrow.ede1bee1.svg";